import React, { useState, useEffect } from "react";
import styles from "./index.module.css";
import { useSelector, useDispatch } from "react-redux";
import { toggleMultiSelectDropdown } from "../../../store/slices/dropdown/toggle.slice";

const MultiselectDropdown = ({ steps, selSteps, name, onChange }) => {
  const dispatch = useDispatch();
  const isClose = useSelector(
    (store) => store.toggleDropdown.multiSelectDropdown
  );
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState(steps);
  const [search, setSearch] = useState("");
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    if (selSteps) {
      let selStepsLowercase = selSteps.map((step) => step?.toLowerCase());
      setSelectedOptions(
        steps.filter((item) => selStepsLowercase.includes(item?.toLowerCase()))
      );
    }
    setIsInitialized(true);
  }, []);

  useEffect(() => {
    // Only call onChange if component is initialized and selectedOptions has changed
    if (isInitialized) {
      onChange(selectedOptions);
    }
  }, [selectedOptions, isInitialized]);

  useEffect(() => {
    if (!selSteps) {
      setSelectedOptions(steps);
    }
  }, [steps]);

  useEffect(() => {
    setIsOpen(false);
  }, [isClose]);

  // Toggle dropdown open/close
  const toggleDropdown = (e) => {
    e.stopPropagation();
    setIsOpen(!isOpen);
    // dispatch(toggleMultiSelectDropdown({ val: !isOpen }));
  };

  // Handle selecting/deselecting options
  const handleSelect = (e, option) => {
    e.stopPropagation();

    if (selectedOptions.includes(option)) {
      setSelectedOptions(selectedOptions.filter((item) => item !== option));
    } else {
      setSelectedOptions([...selectedOptions, option]);
    }
  };

  // Handle 'All' option
  const handleSelectAll = (e) => {
    e.stopPropagation();
    if (selectedOptions.length === steps?.length) {
      setSelectedOptions([]);
    } else {
      setSelectedOptions(steps);
    }
  };

  // Filtered options based on search
  const filteredOptions = steps.filter((option) =>
    option.toLowerCase().includes(search.toLowerCase())
  );

  const formatOptionLabel = (option) => {
    if (option === "aelia_auckland") return "auckland dutyfree";
    return option && option.includes("_") ? option.replace(/_/g, " ") : option;
  };

  return (
    <div className={styles["price-rank-dropdown"]}>
      <button onClick={toggleDropdown} className={styles["dropdown-button"]}>
        <div>
          {selectedOptions.length === steps?.length
            ? `All ${name || ""}`
            : `${selectedOptions.length}`}
        </div>
        <div>
          <div className={styles["down"]}>
            <i class="bi bi-chevron-down" style={{ color: "black" }}></i>
          </div>
        </div>
      </button>
      {isOpen && (
        <div
          className={styles["dropdown-menu"]}
          onClick={(e) => e.stopPropagation()}
        >
          <input
            type="text"
            className={styles["dropdown-search"]}
            placeholder={`Search ${name || ""}`}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{ width: "100%", marginBottom: 8, padding: 6, fontSize: "1.6rem", borderRadius: 4, border: "1px solid #ccc" }}
          />
          <div className={styles["dropdown-item"]}>
            <input
              type="checkbox"
              checked={selectedOptions.length === steps.length}
              onChange={handleSelectAll}
            />
            <label>All {name}</label>
          </div>
          {filteredOptions.map((option) => (
            <div key={option} className={styles["dropdown-item"]}>
              <input
                type="checkbox"
                checked={selectedOptions.includes(option)}
                onChange={(e) => handleSelect(e, option)}
              />
              {option && (
                <label>{formatOptionLabel(option)}</label>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MultiselectDropdown;
